var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourcePerformanceService } from "~/services/domain-service/outsource-performance-manage.service";
import { OutsourceSettleManageService } from "~/services/domain-service/outsource-settle-manage.service";
// @Auth(1003)
var OutsourcePerformanceManageIndex = /** @class */ (function (_super) {
    __extends(OutsourcePerformanceManageIndex, _super);
    function OutsourcePerformanceManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = "1";
        _this.tabPosition = "top";
        _this.queryModelOne = {
            batchNumber: ""
        };
        _this.queryModelTwo = {
            productName: ""
        };
        _this.queryModelThree = {
            outsourceName: ""
        };
        _this.queryModelFour = {};
        _this.batchList = []; //批次号
        _this.productType = []; //产品
        _this.performanceDataListOne = []; //数据列表
        _this.performanceDataListTwo = []; //数据列表
        _this.performanceDataListThree = []; //数据列表
        _this.performanceDataListFour = []; //数据列表
        _this.selectionList = []; //选中数据
        return _this;
    }
    OutsourcePerformanceManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    OutsourcePerformanceManageIndex.prototype.refreshData = function () {
        //默认加载列表
        this.loadDataOne();
        this.loadDataTwo();
        this.loadDataThree();
        this.loadDataFour();
        this.loadDataOutBatchList();
        this.getProductType();
    };
    //委外批次业绩
    OutsourcePerformanceManageIndex.prototype.loadDataOne = function () {
        var _this = this;
        this.outsourcePerformanceService
            .queryCaseOutBathList(this.queryModelOne, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.performanceDataListOne = data;
        });
    };
    //委外产品业绩
    OutsourcePerformanceManageIndex.prototype.loadDataTwo = function () {
        var _this = this;
        this.outsourcePerformanceService
            .queryCaseOutProductList(this.queryModelTwo, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.performanceDataListTwo = data;
        });
    };
    //委外金额业绩
    OutsourcePerformanceManageIndex.prototype.loadDataThree = function () {
        var _this = this;
        this.outsourcePerformanceService
            .queryCaseOutMoneyList(this.queryModelThree, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.performanceDataListThree = data;
        });
    };
    //投诉及质检查询
    OutsourcePerformanceManageIndex.prototype.loadDataFour = function () { };
    //批次号列表
    OutsourcePerformanceManageIndex.prototype.loadDataOutBatchList = function () {
        var _this = this;
        this.outsourcePerformanceService
            .queryOutBatchList({ dataType: "batchNumber" })
            .subscribe(function (data) {
            _this.batchList = data;
        });
    };
    OutsourcePerformanceManageIndex.prototype.getProductType = function () {
        var _this = this;
        this.outsourcePerformanceService
            .queryOutBatchList({ dataType: "productName" })
            .subscribe(function (data) {
            _this.productType = data;
        });
    };
    /**
     * 重置numberRange
     */
    OutsourcePerformanceManageIndex.prototype.follFeedback = function () {
        this.queryModelOne.batchNumber = "";
        this.queryModelTwo.productName = "";
        this.queryModelThree.outsourceName = "";
    };
    __decorate([
        Dependencies(OutsourcePerformanceService)
    ], OutsourcePerformanceManageIndex.prototype, "outsourcePerformanceService", void 0);
    __decorate([
        Dependencies(OutsourceSettleManageService)
    ], OutsourcePerformanceManageIndex.prototype, "OutsourceSettleManageService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutsourcePerformanceManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutsourcePerformanceManageIndex.prototype, "sortService", void 0);
    OutsourcePerformanceManageIndex = __decorate([
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], OutsourcePerformanceManageIndex);
    return OutsourcePerformanceManageIndex;
}(Vue));
export default OutsourcePerformanceManageIndex;
